<div class="text-center">
  <p class="cursor-pointer underline underline-offset-4 decoration-dotted decoration-slate-300 mb-1" tp="{{tooltip()}}">
    {{heading()}}
  </p>
  <div class="flex items-center mx-auto max-w-80">
    <textarea name="{{id()}}" id="{{id()}}" [ngModel]="value()" (ngModelChange)="value.set($event)"
      class="block min-w-0 grow px-4 py-1 text-center outline-none text-green-600 bg-slate-50 border border-slate-200 rounded">
    </textarea>
  </div>
</div>